var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger",class:{'alert-danger': _vm.isError, 'alert-info': _vm.isInfo, 'alert-success': _vm.isSuccess, 'alert-warning': _vm.isWarning}},[_vm._t("message")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }